import { render, staticRenderFns } from "./TargetingLinking.vue?vue&type=template&id=a1b813a6&"
import script from "./TargetingLinking.vue?vue&type=script&lang=js&"
export * from "./TargetingLinking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports